import React from "react";

function Roadmap() {
  return (
    <>
      <div className="bg-[#F2F4F9] relative roadmap-bg ">
        <div
          id="Roadmap"
          className="max-w-[1624px] mx-auto px-4 sm:px-6 lg:px-8 my-12  lg:-mt-10"
        >
          <h2
            className="text-black text-3xl sm:text-5xl  xl:text-[70px] 2xl:text-[100px] text-aircruiser xl:tracking-[-2px] text-shadow-2 text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            Our Roadmap
          </h2>
          <div className="flex flex-wrap md:flex-nowrap md:flex-row mt-10 md:mt-14 xl:mt-20 gap-3 gap-y-10">
            <div className="w-full md:w-1/3">
              <div className="flex flex-col ">
                <div
                  className="flex items-center gap-1"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <div className="border border-black min-w-16 min-h-16 lg:min-w-24 lg:min-h-24 rounded-full flex flex-col justify-center items-center text-3xl sm:text-4xl lg:text-5xl text-shadow-2 text-aircruiser ">
                    1
                  </div>
                  <div className="md:flex items-center  w-full   hidden ">
                    <span className="w-3 h-3 border border-black  rounded-full"></span>
                    <span className="w-full h-[1px] border-t border-dashed border-black"></span>
                    <span className="w-3 h-3 border border-black  rounded-full"></span>
                  </div>
                </div>
                <div className="mt-3 sm:mt-6 md:max-w-[360px] ">
                  <p
                    className="text-black leading-[160%] text-base"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                  >
                    <span className="text-black/50"> Phase - 1</span> Goal:
                    building the bases of the community, raw products
                  </p>
                  <div data-aos="fade-up" data-aos-duration="2500">
                    <h4 className="text-black text-lg  text-aircruiser mt-2">
                      Actionable steps
                    </h4>
                    <ul className="flex flex-col gap-1 text-sm text-black/70 list-disc ps-4 mt-3">
                      <li>Presale</li>
                      <li>Action figure/NFT</li>{" "}
                      <li>Animated series trailer</li>
                      <li>Video game (first version)</li>
                      <li>Having a faithful community</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="w-full md:w-1/3">
              <div className="flex flex-col ">
                <div
                  className="flex items-center gap-1"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <div className="border border-black min-w-16 min-h-16 lg:min-w-24 lg:min-h-24 rounded-full flex flex-col justify-center items-center text-3xl sm:text-4xl lg:text-5xl text-shadow-2 text-aircruiser ">
                    2
                  </div>
                  <div className="  md:flex items-center  w-full   hidden ">
                    <span className="w-3 h-3 border border-black  rounded-full"></span>
                    <span className="w-full h-[1px] border-t border-dashed border-black"></span>
                    <span className="w-3 h-3 border border-black  rounded-full"></span>
                  </div>
                </div>
                <div className="mt-3 sm:mt-6 md:max-w-[360px] ">
                  <p
                    className="text-black leading-[160%] text-base md:max-w-[250px]"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                  >
                    <span className="text-black/50"> Phase - 2 </span>
                    Goal: building momentum and product development
                  </p>
                  <div data-aos="fade-up" data-aos-duration="2500">
                    <h4 className="text-black text-lg  text-aircruiser mt-2">
                      Pre-requisites
                    </h4>
                    <ul className="flex flex-col gap-1 text-sm text-black/70 list-disc ps-4 mt-3">
                      <li>mobile game</li>
                      <li>new website</li> <li>pilot of the series</li>
                    </ul>{" "}
                  </div>
                  <div data-aos="fade-up" data-aos-duration="3000">
                    <h4 className="text-black text-lg  text-aircruiser   mt-4">
                      Actionable steps
                    </h4>
                    <ul className="flex flex-col gap-1 text-sm text-black/70 list-disc ps-4 mt-3">
                      <li>Upgraded game</li>
                      <li>New website (possibly like game.com)</li>
                      <li>S1 of the series</li>
                      <li>New coin launches in the Josh universe</li>
                      <li>Copyrighting the universe</li>
                      <li>Studying other successful coins,</li>
                      <li>learning how to integrate those ideas</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="w-full md:w-1/3">
              <div className="flex flex-col ">
                <div
                  className="flex items-center gap-1"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <div className="border border-black min-w-16 min-h-16 lg:min-w-24 lg:min-h-24 rounded-full flex flex-col justify-center items-center text-3xl sm:text-4xl lg:text-5xl text-shadow-2 text-aircruiser ">
                    3
                  </div>
                </div>
                <div className="mt-3 sm:mt-6 md:max-w-[360px] ">
                  <p
                    className="text-black leading-[160%] text-base md:max-w-[250px]"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                  >
                    <span className="text-black/50"> Phase - 3 </span>
                    IRL marketing, IRL partnerships
                  </p>
                  <div data-aos="fade-up" data-aos-duration="2500">
                    <h4 className="text-black text-lg  text-aircruiser mt-2">
                      Pre-requisites
                    </h4>
                    <ul className="flex flex-col gap-1 text-sm text-black/70 list-disc ps-4 mt-3">
                      <li>Multiple coin launch</li>
                      <li>Copyrighted content</li> <li>Polished video game</li>{" "}
                      <li>Project has a general sense of</li>{" "}
                      <li>direction, like an IP</li>
                    </ul>{" "}
                  </div>
                  <div data-aos="fade-up" data-aos-duration="3000">
                    <h4 className="text-black text-lg  text-aircruiser   mt-4">
                      Actionable steps
                    </h4>
                    <ul className="flex flex-col gap-1 text-sm text-black/70 list-disc ps-4 mt-3">
                      <li>IRL marketing</li>
                      <li>
                        Marketing on: comic-cons, asking Ryan Reynolds to do a
                        DeadPool vs Josh thing, going to video game events
                      </li>
                      <li>
                        Looking for low/medium competition environments mainly{" "}
                      </li>
                      <li>
                        Partnering with sport associates (IDK if that's the
                        right word, but yeah)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Roadmap;
